import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home/Home.vue'
import PrivacyPolicy from '../components/privacy-policy/PrivacyPolicy.vue'
import TermsAndConditions from '../components/terms-and-conditions/TermsAndConditions.vue'
import RegistrationComplete from '../components/registration-complete/RegistrationComplete.vue'
import UnsubscribeSuccessful from '../components/unsubscribe-successful/UnsubscribeSuccessful.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions
  },
  {
    path: '/registration-complete',
    name: 'RegistrationComplete',
    component: RegistrationComplete
  },
  {
    path: '/unsubscribe-successful',
    name: 'UnsubscribeSuccessful',
    component: UnsubscribeSuccessful
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
